
document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.slider_main', {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      0: { slidesPerView: 1.01 },
      480: { slidesPerView: 1.25 },
      576: { slidesPerView: 2 },
      750: { slidesPerView: 3 }
    }
  });

  new Swiper('.product_div', {
    slidesPerView: 2,
    spaceBetween: 50,
    breakpoints: {
      0: { slidesPerView: 1 },
      375: { slidesPerView: 2 }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".mob_menu_list > li");

  items.forEach((item) => {
    const trigger = item.querySelector(".link_mob");
    const submenu = item.querySelector(".mob_sub_menu");

    if (!trigger) return;

    trigger.addEventListener("click", function (e) {
      if (!submenu) return;

      e.preventDefault();

      const isOpen = item.classList.contains("active");

      // Close all others
      items.forEach(i => {
        i.classList.remove("active");
        const sm = i.querySelector(".mob_sub_menu");
        if (sm) sm.style.maxHeight = null;
      });

      // Toggle current
      if (!isOpen) {
        item.classList.add("active");
        submenu.style.maxHeight = submenu.scrollHeight + "px";
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {

  const drawer = document.querySelector("header-drawer");
  const openBtn = document.querySelector(".menu_haburger");
  const closeBtn = document.querySelector(".close_menu");
  const overlay = document.querySelector(".drawer-overlay");

  // Open Drawer
  openBtn?.addEventListener("click", () => {
    drawer.classList.add("open");
    overlay.classList.add("active");
    document.body.classList.add("no-scroll");
  });

  // Close Drawer via Button
  closeBtn?.addEventListener("click", () => {
    drawer.classList.remove("open");
    overlay.classList.remove("active");
    document.body.classList.remove("no-scroll");
  });

  // Close Drawer via Overlay
  overlay?.addEventListener("click", () => {
    drawer.classList.remove("open");
    overlay.classList.remove("active");
    document.body.classList.remove("no-scroll");
  });

});




document.addEventListener('click', function (e) {
  const addBtn = e.target.closest('button[name="add"]');
  if (!addBtn) return;

  // For product cards on grid
  let scope =
    addBtn.closest('.card, .product-card, .grid__item, [data-product-id]') ||
    document;

  // Find the closest script whose id starts with "bundle-data"
  let bundleTag = scope.querySelector('script[id^="bundle-data"]');

  // Fallback for product page (single bundle-data)
  if (!bundleTag) {
    bundleTag = document.querySelector('script[id="bundle-data"]');
  }

  if (!bundleTag) return; // not a bundle product → allow normal ATC

  e.preventDefault();

  let items;
  try {
    items = JSON.parse(bundleTag.textContent);
  } catch (err) {
    console.error('Invalid bundle JSON', err);
    return;
  }

addBtn.classList.add("bundle_disabled");

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  })
  .then(res => {
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  })
  .then(() => {
    window.location.href = '/cart';
  })
  .catch(err => console.error(err));
});


$(document).ready(function(){
    const thumbsSwiper = new Swiper('.thumbs-swiper', {
        watchSlidesProgress: true,
        spaceBetween: 12,
        slidesPerView: 'auto',
        breakpoints: {
        0: {
            direction: 'horizontal',
        },
        576: {
            direction: 'vertical',
        }
        }
    });

    const mainSwiper = new Swiper('.main-swiper', {
        slidesPerView: 1,
        autoHeight: true,
        navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
        },
        thumbs: {
        swiper: thumbsSwiper
        }
    });
        
    // Disable buttons on edges
    mainSwiper.on('reachBeginning', () => {
        document.querySelector('.gallery-prev')?.setAttribute('disabled', true);
    });

    mainSwiper.on('reachEnd', () => {
        document.querySelector('.gallery-next')?.setAttribute('disabled', true);
    });

    mainSwiper.on('fromEdge', () => {
        document.querySelector('.gallery-prev')?.removeAttribute('disabled');
        document.querySelector('.gallery-next')?.removeAttribute('disabled');
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event.data?.variant;
            
            if (!variant || !variant.featured_media) return;

            const mediaId = variant.featured_media.id;
            console.log(mediaId);

            if (!mediaId) return;

            const slides = [...document.querySelectorAll('.main-swiper .swiper-slide')];
            const index = slides.findIndex(
            slide => slide.dataset.mediaId == mediaId
            );

            if (index >= 0) {
            mainSwiper.slideTo(index);
            }

        });
    }



    if ((window.location.search.includes('customer_posted=true') || window.location.search.includes('contact_posted=true')) && window.location.hash) {
        var $section = $(window.location.hash).closest('section');

        if ($section.length) {
          $('html, body').animate({
            scrollTop: $section.offset().top - ($('sticky-header').outerHeight() + $('.announcement-bar-section').outerHeight())
          }, 800);
        }
      }


      const observer = new MutationObserver(function () {
      const successBox = document.querySelector('.after_form_submit');

      if (
        successBox &&
        successBox.style.display !== 'none' &&
        successBox.innerText.trim() !== ''
      ) {
        const parentSection = successBox.closest('section') || successBox.parentElement;

        if (parentSection) {
          const offsetTop = parentSection.offsetTop;

          window.scrollTo({
            top: offsetTop - ($('sticky-header').outerHeight() + $('.announcement-bar-section').outerHeight()),
            behavior: 'smooth'
          });
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

});

document.addEventListener('DOMContentLoaded', function () {
    const playIcons = document.querySelectorAll('.ply_icn');
    const modal = document.querySelector('.vdo_modal');

    if (!modal) return; // 👈 IMPORTANT FIX

    const popups = modal.querySelectorAll('.vdo_popup');
    const closeBtn = modal.querySelector('.vdo_modal_close');

    function closeModal() {
        modal.classList.remove('active');
        document.body.classList.remove('no-scroll');

        popups.forEach(popup => {
            const video = popup.querySelector('video');
            if (video) video.pause();
        });
    }

    playIcons.forEach((icon, index) => {
        icon.addEventListener('click', function () {
            popups.forEach(popup => popup.style.display = 'none');

            const activePopup = modal.querySelector(`.vdo_popup[data-index="${index + 1}"]`);
            if (activePopup) {
                activePopup.style.display = 'block';
                const video = activePopup.querySelector('video');
                if (video) video.play();
            }

            modal.classList.add('active');
            document.body.classList.add('no-scroll');
        });
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
    }

    modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
    });
});



// On load header scroll

document.addEventListener("DOMContentLoaded", function() {
  const body = document.body;
  function checkScroll() {
    if (window.scrollY > 0) {
      body.classList.add("scrolled-past-header");
    } else {
      body.classList.remove("scrolled-past-header");
    }
  }

  // Run when page loads or reloads
  checkScroll();

  // Also run on scroll
  window.addEventListener("scroll", checkScroll);
});
